import { render, staticRenderFns } from "./FastFormat.vue?vue&type=template&id=6828ff98&"
import script from "./FastFormat.vue?vue&type=script&lang=js&"
export * from "./FastFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports